
import PublicService from "@/services/public.service";
import moment from "moment";

/**
 * @classdesc Un champ du formulaire
 * @kind class
 * @export
 * @prop {int} id - Id du champ
 * @prop {int} id_module - Id du module
 * @prop {string} nom - Nom du champ
 * @prop {int} ordre - Ordre du champ
 * @prop {string} type_champ - Champ général ou spécifique 
 * @prop {string} type - Type de champs
 * @prop {string} label - Label du champs
 * @prop {string} options - Options disponible si le type = select
 * @prop {boolean} mandatory - La metadonnée est obligatoire
 * @prop {string} condition_nom - Nom du champ dépendante
 * @prop {string} condition_operateur - Operateur de comparaison
 * @prop {string} condition_valeur - Valeur de la condition
 * @prop {string} content - Contenu d'un champ HTML
 * @class Champ_Formulaire
   */

export default class Champ_Formulaire {
    id = "";
    id_module = "";
    nom = "";
    ordre = 0;
    type_champ = "general";
    label = "";
    type = "text";
    options = "";
    mandatory = 0;
    has_metadatas = 0;
    condition_nom = "";
    condition_operateur = "";
    condition_valeur = "";
    condition_nom_2 = "";
    condition_operateur_2 = "";
    condition_valeur_2 = "";
    value = "";
    content = "";
    /**
     * Creates an instance of Champ_Formulaire.
     * @constructs
     * @kind function
     * @memberof Champ_Formulaire
     */
    constructor() { }

    /**
 * Défini un champ à partir d'un jeu de données
 *
 * @param {Object} data
 * @memberof Champ_Formulaire
 */
    set(data) {
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
        if (this.value == null || this.value == undefined || this.value == "") {
            this.set_default_value();
        }

    }

    set_default_value() {
        if (this.type == "select" && this.nom == "sexe") {
            this.value = "M";
            return;
        }
        if (this.type == "select" && this.nom == "pays") {
            this.value = "FRA";
            return;
        }
        if (this.type == "select" && this.nom == "nationalite") {
            this.value = "FRA";
            return;
        }
        if (this.type == "select" && this.nom == "type_document") {
            this.value = "Sélectionnez le type de document";
            return;
        }
        if (this.type == "select") {
            this.value = "";
        }
        if (this.type == "boolean") {
            this.value = "";
        }

    }

    async get_selection_with_metadatas() {
        let request = await PublicService.getOptionsForChampFormulaire(this.id, this.value);
        if (request) {
            return request;
        }
        return null;
    }

    condition_met(val, condition_number = 1) {
        let current_operator = this.condition_operateur;
        let current_value = this.condition_valeur;
        if (condition_number == 2) {
            current_operator = this.condition_operateur_2;
            current_value = this.condition_valeur_2;
        }
        switch (current_operator) {
            case 'egal':
                return this.verify_egality(current_value, val);
            case 'different':
                return current_value != val && val != "" && val != null;
            case 'superieur':
                return this.condition_met_superieur(val, current_value);
            case 'inferieur':
                return this.condition_met_inferieur(val, current_value);
            case 'superieur_egal':
                return parseFloat(val) >= parseFloat(current_value);
            case 'inferieur_egal':
                return parseFloat(val) <= parseFloat(current_value);
            case 'contient':
                let options = current_value.split(";");
                for (let i = 0; i < options.length; i++) {
                    if (val.toString().includes(options[i])) {
                        return true;
                    }
                }
                return false;
            case 'contient_pas':
                return !val.includes(current_value);
            case 'entre':
                let range = current_value.split(";");
                return parseFloat(val) < parseFloat(range[1]) && parseFloat(val) > parseFloat(range[0]);
            default:
                return true;
        }
    }

    condition_met_superieur(val, current_value) {

        if (moment(val).isValid()) {
            if (moment(current_value).isValid()) {
                return moment(val).isAfter(moment(current_value));
            }
            return false;
        }
        return parseFloat(val) > parseFloat(current_value);
    }


    condition_met_inferieur(val, current_value) {
        if (moment(val).isValid()) {
            if (moment(current_value).isValid()) {
                return moment(val).isBefore(moment(current_value));
            }
            return false;
        }
        return moment(val).isBefore(moment(current_value));

    }

    verify_egality(condition, val) {
        if (val == undefined) {
            return true;
        }

        if (isNaN(parseInt(val))) {
            return condition == val || condition.toLowerCase() == val.toLowerCase() || condition.toUpperCase() == val.toUpperCase();
        }
        else {
            return condition == val;
        }

    }

    is_valid_num_ffa() {
        if (!this.value.match("^[0-9]{7}$") && !this.value.match("^[0-9]{6}$")) {
            return false;
        }
        return true;
    }
    is_valid_num_fftri() {
        if (!this.value || !this.value.match("^[0-9A-Z]{5,10}$")) {
            return false;
        }
        return true;
    }
    is_valid_num_pps() {
        if (!this.value.match("^[0-9A-Z]{11}$")) {
            return false;
        }
        return true;
    }

    is_valid_num_licence_FFR() {
        if (!this.value.match("^[0-9]{7}[A-Z]$")) {
            return false;
        }
        return true;
    }


    is_disabled(initial_commande_inscription) {
        if (!this.initial_commande_inscription) return false;
        if (champ.nom == "nom" || champ.nom == "prenom" || champ.nom == "date_naissance" || champ.nom == "sexe" || champ.nom == "club") {
            return true;
        }
        for (const item of Object.entries(this.initial_commande_inscription.inscriptions[0].champs)) {
            if (item[0] == champ.nom) {
                return true;
            }
        }
        return false;
    }

}